module.exports = __webpack_public_path__ + "img/info-light.780cc6dd.svg";